import { render, staticRenderFns } from "./TierFormDialog.vue?vue&type=template&id=4cbfd4ca&scoped=true"
import script from "./TierFormDialog.vue?vue&type=script&lang=js"
export * from "./TierFormDialog.vue?vue&type=script&lang=js"
import style0 from "./TierFormDialog.vue?vue&type=style&index=0&id=4cbfd4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbfd4ca",
  null
  
)

export default component.exports